import { TrustSubType } from "@models/trusts/trusts-enums";

export const trustEstablishmentActions = {
  discretionaryTrust: {
    title: 'Discretionary Trust',
    description: `With 'Discretionary Trust', decisions as to who or what entity will receive allocations of income derived by the Trust are determined at the discretion of the trustee.`,
  },
  discretionaryTrustWithFbe: {
    title: 'Discretionary Trust with Foreign Beneficiary Exclusion (FBE)',
    description: `Our Discretionary Trust products are designed with a specific risk profile in mind. Under a Discretionary Trust, the trustee has the discretion to decide which beneficiaries or entities will receive allocations of the trust’s income.
The Foreign Beneficiary Exclusion is included to ensure the trust is not subject to stamp duty surcharges or land tax surcharges when acquiring residential property. While the legislation differs between States, all States impose these surcharges on residential property, and some also extend them to commercial, industrial, or farmland.`,
  },
  discretionaryTrustWithForeignBeneficiary: {
    title: 'Discretionary Trust with Foreign Beneficiary',
    description: `The 'Foreign Beneficiary Exclusion' is put in place so that the trust will not pay stamp duty surcharges and land tax surcharge if the trust purchases residential properties (the legislation in each state is different but all states catch residential property - some catch commercial, industrial and farmland as well).`,
  },
  hybridDiscretionaryTrust: {
    title: 'Hybrid Discretionary Trust',
    description: `This trust is a Discretionary Trust with an additional feature which enables the Trustee to issue units to beneficiaries to create fixed entitlements to capital and to income of the trust. It is modelled on the Discretionary Trust but has additional annexures relating to the units - the application and transfer of them.`,
  },
  hybridDiscretionaryTrustWithForeignBeneficiaryExclusionFBE: {
    title: 'Hybrid Discretionary Trust with Foreign Beneficiary Exclusion (FBE)',
    description: `This Discretionary Trust allows the Trustee to issue units, creating fixed entitlements to capital and income. It includes annexures for unit application and transfer. A Foreign Beneficiary Exclusion prevents stamp duty and land tax surcharges on residential property purchases, varying by State.`,
  },
  standardUnitTrust: {
    title: 'Standard Unit Trust',
    description: `The 'Standard Unit Trust' deed comes with an ability on the part of the trustee to allocate numerous differing classes of units, with differing rights. It has all the elements of any other trust, except that the interests and rights of the beneficiaries depend on the type of units they are issued with, and these rights are set out on unit certificates.`,
  },
  fixedUnitTrustForIncomeTaxPurposes: {
    title: 'Fixed Unit Trust for Income Tax Purposes',
    description: `The 'Fixed Unit Trust' contains provisions which are set out in a practice compliance guideline issued bu the Commissioner if Taxation as to what constitutes a fixed unit trust for income tax purposes. Within this ded there are references to the practice compliance guidelines.`,
  },
  SISRegUnitTrust: {
    title: 'SIS Reg 13.22C Unit Trust',
    description: `The SIS Regulation 13.22C Unit Trust complies with the requirements of regulation 13.22C of the Supervision Industry (Supervision) Act 1993. This allows a Self-Managed Superannuation Fund (SMSF) to invest 100% of its assets in these trusts without breaching the in-house asset rule.The trust deed must contain specific restrictions under SIS regulations 13.22C and 13.22D, which prevent the trustee from borrowing money, investing in other trusts or companies, or operating a business. These trusts are strictly passive entities.`,
  },
  nonControlledUnitTrust: {
    title: 'Non-Controlled Unit Trust',
    description: `The 'Non-Controlled Unit Trust' is a product created to enable an SMSF to invest in a private unit trust, without breaching what is known as the in house asset rule. It is a product for the same purpose as the SIS Reg 13.22C trust, but it is structured in differently and has different restrictions. These trust can borrow, a SIS Reg 13.22 C trust cannot. These trusts can also invest in other trusts, and carry on a business - a SIS Reg 13.22C trust.`,
  },
  NSWLandTaxUnitTrust: {
    title: 'NSW Land Tax Unit Trust',
    description: `This special purpose unit trust is drafted to accommodate the legislation within the NSW Land Tax act which sets specific requirements as to what can constitute a "fixed" trust for NSW land tax purposes.`,
  }
};

export const trustEstablishmentHeaders: Record<TrustSubType, string> = {
  [TrustSubType.Discretionary]: trustEstablishmentActions.discretionaryTrust.title,
  [TrustSubType.DiscretionaryWithFBE]: trustEstablishmentActions.discretionaryTrustWithFbe.title,
  [TrustSubType.DiscretionaryCapitalReserved]: trustEstablishmentActions.hybridDiscretionaryTrust.title,
  [TrustSubType.DiscretionaryFullyReserved]: trustEstablishmentActions.hybridDiscretionaryTrustWithForeignBeneficiaryExclusionFBE.title,
  [TrustSubType.Fixed]: trustEstablishmentActions.fixedUnitTrustForIncomeTaxPurposes.title,
  [TrustSubType.NonFixed]: trustEstablishmentActions.standardUnitTrust.title,
  [TrustSubType.NSWLandTax]: trustEstablishmentActions.NSWLandTaxUnitTrust.title,
  [TrustSubType.Unit]: '',
};

export const trustEstablishmentSubheaders: Record<TrustSubType, string> = {
  [TrustSubType.Discretionary]: '',
  [TrustSubType.DiscretionaryWithFBE]: '',
  [TrustSubType.DiscretionaryCapitalReserved]: '',
  [TrustSubType.DiscretionaryFullyReserved]: '',
  [TrustSubType.Fixed]: '',
  [TrustSubType.NonFixed]: '',
  [TrustSubType.NSWLandTax]: '',
  [TrustSubType.Unit]: '',
};


export const trustEstablishmentFormKeys: Record<TrustSubType, string> = {
  [TrustSubType.Discretionary]: 'discretionary',
  [TrustSubType.DiscretionaryWithFBE]: 'discretionary-fbe',
  [TrustSubType.DiscretionaryCapitalReserved]: 'hybrid-discretionary',
  [TrustSubType.DiscretionaryFullyReserved]: 'hybrid-discretionary-fbe',
  [TrustSubType.Fixed]: 'fixed',
  [TrustSubType.NonFixed]: 'unit-trust-establishment',
  [TrustSubType.NSWLandTax]: '',
  [TrustSubType.Unit]: '',
};

export function getTrustEstablishmentChangeType(subType: TrustSubType): string {
  let changeType = 't:';

  switch (subType) {
    case TrustSubType.Discretionary:
      changeType += 'discretionary';
      break;
    case TrustSubType.DiscretionaryWithFBE:
      changeType += 'discretionary-fbe';
      break;
    case TrustSubType.DiscretionaryCapitalReserved:
      changeType += 'hybrid-discretionary';
      break;
    case TrustSubType.DiscretionaryFullyReserved:
      changeType += 'hybrid-discretionary-fbe';
      break;
    case TrustSubType.Fixed:
      changeType += 'fixed';
      break;
    case TrustSubType.NonFixed:
      changeType += 'non-fixed';
      break;
    case TrustSubType.NSWLandTax:
      changeType += 'nsw-land-tax';
      break;
    case TrustSubType.Unit:
      changeType += 'standard-unit';
      break;
    default:
      changeType += 'establishment';
  }

  return changeType;
}

export function isTrustEstablishmentDocumentType(documentType: string): boolean {
  return [
    TrustSubType.Discretionary,
    TrustSubType.DiscretionaryCapitalReserved,
    TrustSubType.DiscretionaryFullyReserved,
    TrustSubType.Fixed,
    TrustSubType.NonFixed,
    TrustSubType.NSWLandTax,
    TrustSubType.Unit,
  ]
    .map((subtype) => getTrustEstablishmentChangeType(subtype))
    .includes(documentType);
}
